import { render, staticRenderFns } from "./CoverBlock.vue?vue&type=template&id=7187f744&scoped=true"
import script from "./CoverBlock.vue?vue&type=script&lang=js"
export * from "./CoverBlock.vue?vue&type=script&lang=js"
import style0 from "./CoverBlock.vue?vue&type=style&index=0&id=7187f744&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187f744",
  null
  
)

export default component.exports